<ng-container rtBlock="sc-blog-article-card">
    <a rtElem="link" qa-dataid="blog-article-card" [routerLink]="path()" [attr.aria-label]="title()"></a>

    <div rtElem="image" aria-hidden="true">
        @if (imageSrc(); as src) {
            <img
                rtElem="img"
                loading="lazy"
                decoding="async"
                sizes="(width <= 640px) 100vw, 640px"
                [src]="src"
                [attr.srcset]="imageSrcset()"
                [alt]="title()" />
        } @else {
            @switch (slug()) {
                @case ('room-length') {
                    <svg rtElem="svg" viewBox="0 0 200 140" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
                        <g fill="none" stroke="currentColor" stroke-width="1.5">
                            <rect x="30" y="40" width="140" height="50" />
                            <line x1="30" y1="110" x2="170" y2="110" />
                            <path d="M30 105 L30 115 M170 105 L170 115" />
                            <path d="M40 110 L30 105 L30 115 Z M160 110 L170 105 L170 115 Z" fill="currentColor" />
                        </g>
                        <text
                            x="100"
                            y="128"
                            text-anchor="middle"
                            fill="currentColor"
                            font-family="JetBrains Mono, monospace"
                            font-size="10">
                            L
                        </text>
                    </svg>
                }
                @case ('room-width') {
                    <svg rtElem="svg" viewBox="0 0 140 200" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
                        <g fill="none" stroke="currentColor" stroke-width="1.5">
                            <rect x="40" y="30" width="50" height="140" />
                            <line x1="110" y1="30" x2="110" y2="170" />
                            <path d="M105 30 L115 30 M105 170 L115 170" />
                            <path d="M110 40 L105 30 L115 30 Z M110 160 L105 170 L115 170 Z" fill="currentColor" />
                        </g>
                        <text
                            x="125"
                            y="103"
                            text-anchor="middle"
                            fill="currentColor"
                            font-family="JetBrains Mono, monospace"
                            font-size="10">
                            W
                        </text>
                    </svg>
                }
                @case ('opening-lock') {
                    <svg rtElem="svg" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
                        <g fill="none" stroke="currentColor" stroke-width="1.5">
                            <rect x="30" y="50" width="140" height="100" />
                            <rect x="80" y="80" width="40" height="40" stroke-dasharray="3 3" />
                            <rect x="118" y="100" width="40" height="32" fill="var(--sc-color-paper)" />
                            <path d="M127 100 L127 92 Q127 84 138 84 Q149 84 149 92 L149 100" />
                            <circle cx="138" cy="116" r="3" fill="currentColor" />
                            <line x1="138" y1="116" x2="138" y2="124" />
                        </g>
                    </svg>
                }
                @case ('opening-width') {
                    <svg rtElem="svg" viewBox="0 0 200 140" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
                        <g fill="none" stroke="currentColor" stroke-width="1.5">
                            <rect x="20" y="30" width="160" height="50" stroke-dasharray="3 3" />
                            <rect x="50" y="40" width="100" height="30" />
                            <line x1="50" y1="100" x2="150" y2="100" />
                            <path d="M60 100 L50 95 L50 105 Z M140 100 L150 95 L150 105 Z" fill="currentColor" />
                        </g>
                        <text
                            x="100"
                            y="120"
                            text-anchor="middle"
                            fill="currentColor"
                            font-family="JetBrains Mono, monospace"
                            font-size="10">
                            width
                        </text>
                    </svg>
                }
                @case ('opening-position-x') {
                    <svg rtElem="svg" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
                        <g fill="none" stroke="currentColor" stroke-width="1.5">
                            <rect x="30" y="30" width="140" height="140" />
                            <rect x="80" y="60" width="50" height="40" />
                            <line x1="30" y1="120" x2="80" y2="120" stroke-dasharray="2 3" />
                            <path d="M40 120 L30 115 L30 125 Z M70 120 L80 115 L80 125 Z" fill="currentColor" />
                        </g>
                        <text
                            x="55"
                            y="138"
                            text-anchor="middle"
                            fill="currentColor"
                            font-family="JetBrains Mono, monospace"
                            font-size="11">
                            X
                        </text>
                    </svg>
                }
                @case ('opening-position-y') {
                    <svg rtElem="svg" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
                        <g fill="none" stroke="currentColor" stroke-width="1.5">
                            <rect x="30" y="30" width="140" height="140" />
                            <rect x="100" y="80" width="40" height="50" />
                            <line x1="120" y1="30" x2="120" y2="80" stroke-dasharray="2 3" />
                            <path d="M120 40 L115 30 L125 30 Z M120 70 L115 80 L125 80 Z" fill="currentColor" />
                        </g>
                        <text
                            x="138"
                            y="58"
                            text-anchor="middle"
                            fill="currentColor"
                            font-family="JetBrains Mono, monospace"
                            font-size="11">
                            Y
                        </text>
                    </svg>
                }
                @case ('tread-thickness') {
                    <svg rtElem="svg" viewBox="0 0 200 140" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
                        <g fill="none" stroke="currentColor" stroke-width="1.5">
                            <rect x="30" y="50" width="140" height="20" />
                            <line x1="190" y1="50" x2="190" y2="70" />
                            <path d="M185 50 L195 50 M185 70 L195 70" />
                            <path d="M190 56 L185 50 L195 50 Z M190 64 L185 70 L195 70 Z" fill="currentColor" />
                        </g>
                        <text x="170" y="90" text-anchor="end" fill="currentColor" font-family="JetBrains Mono, monospace" font-size="10">
                            t
                        </text>
                    </svg>
                }
                @case ('stringer-type') {
                    <svg rtElem="svg" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
                        <g fill="none" stroke="currentColor" stroke-width="1.5">
                            <path
                                d="M30 170 L30 140 L70 140 L70 110 L110 110 L110 80 L150 80 L150 50 L180 50 L180 60 L160 60 L160 90 L120 90 L120 120 L80 120 L80 150 L40 150 L40 180 Z" />
                            <line x1="30" y1="170" x2="180" y2="50" stroke-dasharray="3 3" stroke-width="1" />
                        </g>
                    </svg>
                }
                @case ('riser-height') {
                    <svg rtElem="svg" viewBox="0 0 200 140" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
                        <g fill="none" stroke="currentColor" stroke-width="1.5">
                            <path d="M30 110 L90 110 L90 70 L150 70 L150 30" />
                            <line x1="110" y1="70" x2="110" y2="110" />
                            <path d="M105 70 L115 70 M105 110 L115 110" />
                            <path d="M110 78 L105 70 L115 70 Z M110 102 L105 110 L115 110 Z" fill="currentColor" />
                        </g>
                        <text
                            x="124"
                            y="95"
                            text-anchor="middle"
                            fill="currentColor"
                            font-family="JetBrains Mono, monospace"
                            font-size="11">
                            h
                        </text>
                    </svg>
                }
                @case ('tread-depth') {
                    <svg rtElem="svg" viewBox="0 0 200 140" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
                        <g fill="none" stroke="currentColor" stroke-width="1.5">
                            <path d="M30 100 L90 100 L90 60 L150 60 L150 30" />
                            <line x1="90" y1="85" x2="150" y2="85" />
                            <path d="M90 80 L90 90 M150 80 L150 90" />
                            <path d="M98 85 L90 80 L90 90 Z M142 85 L150 80 L150 90 Z" fill="currentColor" />
                        </g>
                        <text
                            x="120"
                            y="107"
                            text-anchor="middle"
                            fill="currentColor"
                            font-family="JetBrains Mono, monospace"
                            font-size="11">
                            d
                        </text>
                    </svg>
                }
                @case ('step-count') {
                    <svg rtElem="svg" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
                        <g fill="none" stroke="currentColor" stroke-width="1.5">
                            <path d="M30 175 L30 150 L65 150 L65 120 L100 120 L100 90 L135 90 L135 60 L170 60 L170 35" />
                        </g>
                        <text
                            x="125"
                            y="165"
                            text-anchor="middle"
                            fill="currentColor"
                            font-family="JetBrains Mono, monospace"
                            font-size="13">
                            N
                        </text>
                    </svg>
                }
                @case ('stair-angle') {
                    <svg rtElem="svg" viewBox="0 0 200 140" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
                        <g fill="none" stroke="currentColor" stroke-width="1.5">
                            <path d="M30 110 L170 110 L170 30 Z" />
                            <path d="M62 110 A32 32 0 0 0 57 94" />
                        </g>
                        <text
                            x="72"
                            y="101"
                            text-anchor="middle"
                            fill="currentColor"
                            font-family="JetBrains Mono, monospace"
                            font-size="12">
                            α
                        </text>
                    </svg>
                }
                @case ('floor-run') {
                    <svg rtElem="svg" viewBox="0 0 200 140" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
                        <g fill="none" stroke="currentColor" stroke-width="1.5">
                            <path d="M30 30 L30 110 L170 110 Z" />
                            <line x1="30" y1="125" x2="170" y2="125" />
                            <path d="M30 120 L30 130 M170 120 L170 130" />
                            <path d="M38 125 L30 120 L30 130 Z M162 125 L170 120 L170 130 Z" fill="currentColor" />
                        </g>
                        <text
                            x="100"
                            y="122"
                            text-anchor="middle"
                            fill="currentColor"
                            font-family="JetBrains Mono, monospace"
                            font-size="11">
                            L
                        </text>
                    </svg>
                }
                @case ('stringer-length') {
                    <svg rtElem="svg" viewBox="0 0 200 140" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
                        <g fill="none" stroke="currentColor" stroke-width="1.5">
                            <path d="M30 110 L170 110 L170 30" />
                            <line x1="30" y1="110" x2="170" y2="30" />
                        </g>
                        <text x="88" y="62" text-anchor="middle" fill="currentColor" font-family="JetBrains Mono, monospace" font-size="12">
                            S
                        </text>
                    </svg>
                }
                @case ('headroom') {
                    <svg rtElem="svg" viewBox="0 0 200 170" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
                        <g fill="none" stroke="currentColor" stroke-width="1.5">
                            <line x1="20" y1="30" x2="180" y2="30" />
                            <path d="M30 150 L30 130 L60 130 L60 110 L90 110 L90 90 L120 90 L120 70 L150 70" />
                            <line x1="90" y1="35" x2="90" y2="85" />
                            <path d="M85 35 L95 35 M85 85 L95 85" />
                            <path d="M90 43 L85 35 L95 35 Z M90 77 L85 85 L95 85 Z" fill="currentColor" />
                        </g>
                        <text
                            x="103"
                            y="64"
                            text-anchor="middle"
                            fill="currentColor"
                            font-family="JetBrains Mono, monospace"
                            font-size="11">
                            H
                        </text>
                    </svg>
                }
                @case ('blondel-formula') {
                    <svg rtElem="svg" viewBox="0 0 200 140" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
                        <g fill="none" stroke="currentColor" stroke-width="1.5">
                            <path d="M40 110 L100 110 L100 70 L160 70 L160 50" />
                            <line x1="80" y1="70" x2="80" y2="110" />
                            <path d="M75 70 L85 70 M75 110 L85 110" />
                            <path d="M80 78 L75 70 L85 70 Z M80 102 L75 110 L85 110 Z" fill="currentColor" />
                            <line x1="100" y1="90" x2="160" y2="90" />
                            <path d="M100 85 L100 95 M160 85 L160 95" />
                            <path d="M108 90 L100 85 L100 95 Z M152 90 L160 85 L160 95 Z" fill="currentColor" />
                        </g>
                        <text x="68" y="94" text-anchor="middle" fill="currentColor" font-family="JetBrains Mono, monospace" font-size="11">
                            H
                        </text>
                        <text
                            x="130"
                            y="108"
                            text-anchor="middle"
                            fill="currentColor"
                            font-family="JetBrains Mono, monospace"
                            font-size="11">
                            D
                        </text>
                    </svg>
                }
                @case ('wood-volume') {
                    <svg rtElem="svg" viewBox="0 0 200 160" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
                        <g fill="none" stroke="currentColor" stroke-width="1.5">
                            <path d="M60 70 L120 70 L120 130 L60 130 Z" />
                            <path d="M60 70 L90 50 L150 50 L120 70" />
                            <path d="M120 70 L150 50 L150 110 L120 130" />
                        </g>
                        <text
                            x="90"
                            y="152"
                            text-anchor="middle"
                            fill="currentColor"
                            font-family="JetBrains Mono, monospace"
                            font-size="12">
                            m³
                        </text>
                    </svg>
                }
                @case ('weight') {
                    <svg rtElem="svg" viewBox="0 0 200 160" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
                        <g fill="none" stroke="currentColor" stroke-width="1.5">
                            <path d="M30 150 L30 125 L65 125 L65 100 L100 100 L100 75 L135 75 L135 50 L170 50" />
                            <line x1="100" y1="25" x2="100" y2="58" />
                            <path d="M93 50 L100 60 L107 50 Z" fill="currentColor" />
                        </g>
                        <text
                            x="122"
                            y="42"
                            text-anchor="middle"
                            fill="currentColor"
                            font-family="JetBrains Mono, monospace"
                            font-size="12">
                            kg
                        </text>
                    </svg>
                }
                @case ('geometry') {
                    <svg rtElem="svg" viewBox="0 0 200 140" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
                        <g fill="none" stroke="currentColor" stroke-width="1.5">
                            <path d="M30 110 L80 110 L80 75 L130 75 L130 40 L170 40" />
                            <line x1="60" y1="75" x2="60" y2="110" />
                            <path d="M55 75 L65 75 M55 110 L65 110" />
                            <path d="M60 83 L55 75 L65 75 Z M60 102 L55 110 L65 110 Z" fill="currentColor" />
                            <line x1="80" y1="92" x2="130" y2="92" />
                            <path d="M80 87 L80 97 M130 87 L130 97" />
                            <path d="M88 92 L80 87 L80 97 Z M122 92 L130 87 L130 97 Z" fill="currentColor" />
                        </g>
                        <text x="48" y="96" text-anchor="middle" fill="currentColor" font-family="JetBrains Mono, monospace" font-size="11">
                            h
                        </text>
                        <text
                            x="105"
                            y="110"
                            text-anchor="middle"
                            fill="currentColor"
                            font-family="JetBrains Mono, monospace"
                            font-size="11">
                            d
                        </text>
                    </svg>
                }
                @case ('railing') {
                    <svg rtElem="svg" viewBox="0 0 200 140" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
                        <g fill="none" stroke="currentColor" stroke-width="1.5">
                            <line x1="30" y1="40" x2="170" y2="40" stroke-width="2.5" />
                            <line x1="30" y1="110" x2="170" y2="110" />
                            <line x1="30" y1="40" x2="30" y2="110" stroke-width="2" />
                            <line x1="170" y1="40" x2="170" y2="110" stroke-width="2" />
                            <line x1="62" y1="42" x2="62" y2="110" />
                            <line x1="88" y1="42" x2="88" y2="110" />
                            <line x1="114" y1="42" x2="114" y2="110" />
                            <line x1="140" y1="42" x2="140" y2="110" />
                        </g>
                    </svg>
                }
                @case ('railing-enable') {
                    <svg rtElem="svg" viewBox="0 0 200 140" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
                        <g fill="none" stroke="currentColor" stroke-width="1.5">
                            <line x1="35" y1="55" x2="120" y2="55" stroke-width="2.5" />
                            <line x1="35" y1="55" x2="35" y2="115" stroke-width="2" />
                            <line x1="120" y1="55" x2="120" y2="115" stroke-width="2" />
                            <line x1="35" y1="115" x2="120" y2="115" />
                            <line x1="65" y1="57" x2="65" y2="115" />
                            <line x1="90" y1="57" x2="90" y2="115" />
                            <path d="M140 78 L153 93 L178 52" stroke-width="2.5" />
                        </g>
                    </svg>
                }
                @case ('railing-top') {
                    <svg rtElem="svg" viewBox="0 0 200 140" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
                        <g fill="none" stroke="currentColor" stroke-width="1.5">
                            <line x1="20" y1="90" x2="115" y2="90" stroke-width="2" />
                            <line x1="115" y1="90" x2="115" y2="130" />
                            <line x1="30" y1="45" x2="110" y2="45" stroke-width="2.5" />
                            <line x1="30" y1="45" x2="30" y2="90" stroke-width="2" />
                            <line x1="110" y1="45" x2="110" y2="90" stroke-width="2" />
                            <line x1="55" y1="47" x2="55" y2="90" />
                            <line x1="80" y1="47" x2="80" y2="90" />
                            <path d="M125 112 L185 112" stroke-dasharray="3 3" />
                        </g>
                    </svg>
                }
                @case ('railing-side') {
                    <svg rtElem="svg" viewBox="0 0 200 140" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
                        <g fill="none" stroke="currentColor" stroke-width="1.5">
                            <rect x="60" y="25" width="90" height="90" />
                            <line x1="60" y1="43" x2="150" y2="43" />
                            <line x1="60" y1="61" x2="150" y2="61" />
                            <line x1="60" y1="79" x2="150" y2="79" />
                            <line x1="60" y1="97" x2="150" y2="97" />
                            <line x1="54" y1="25" x2="54" y2="115" stroke-width="3" />
                        </g>
                    </svg>
                }
                @case ('railing-height') {
                    <svg rtElem="svg" viewBox="0 0 200 140" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
                        <g fill="none" stroke="currentColor" stroke-width="1.5">
                            <path d="M30 110 L70 110 L70 90 L110 90" />
                            <line x1="40" y1="35" x2="150" y2="35" stroke-width="2.5" />
                            <line x1="50" y1="35" x2="50" y2="110" stroke-width="2" />
                            <line x1="140" y1="35" x2="140" y2="90" stroke-width="2" />
                            <line x1="100" y1="40" x2="100" y2="106" />
                            <path d="M95 40 L105 40 M95 106 L105 106" />
                            <path d="M100 48 L95 40 L105 40 Z M100 98 L95 106 L105 106 Z" fill="currentColor" />
                        </g>
                        <text
                            x="112"
                            y="77"
                            text-anchor="middle"
                            fill="currentColor"
                            font-family="JetBrains Mono, monospace"
                            font-size="11">
                            h
                        </text>
                    </svg>
                }
                @case ('handrail-width') {
                    <svg rtElem="svg" viewBox="0 0 200 140" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
                        <g fill="none" stroke="currentColor" stroke-width="1.5">
                            <rect x="65" y="50" width="70" height="34" rx="14" />
                            <line x1="65" y1="105" x2="135" y2="105" />
                            <path d="M65 100 L65 110 M135 100 L135 110" />
                            <path d="M73 105 L65 100 L65 110 Z M127 105 L135 100 L135 110 Z" fill="currentColor" />
                        </g>
                        <text
                            x="100"
                            y="124"
                            text-anchor="middle"
                            fill="currentColor"
                            font-family="JetBrains Mono, monospace"
                            font-size="11">
                            w
                        </text>
                    </svg>
                }
                @case ('baluster-width') {
                    <svg rtElem="svg" viewBox="0 0 200 140" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
                        <g fill="none" stroke="currentColor" stroke-width="1.5">
                            <rect x="88" y="42" width="24" height="78" />
                            <line x1="88" y1="30" x2="112" y2="30" />
                            <path d="M88 25 L88 35 M112 25 L112 35" />
                            <path d="M94 30 L88 25 L88 35 Z M106 30 L112 25 L112 35 Z" fill="currentColor" />
                        </g>
                        <text
                            x="100"
                            y="135"
                            text-anchor="middle"
                            fill="currentColor"
                            font-family="JetBrains Mono, monospace"
                            font-size="11">
                            b
                        </text>
                    </svg>
                }
                @case ('baluster-spacing') {
                    <svg rtElem="svg" viewBox="0 0 200 140" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
                        <g fill="none" stroke="currentColor" stroke-width="1.5">
                            <line x1="30" y1="35" x2="170" y2="35" stroke-width="2" />
                            <line x1="30" y1="110" x2="170" y2="110" />
                            <rect x="60" y="37" width="14" height="73" />
                            <rect x="110" y="37" width="14" height="73" />
                            <line x1="74" y1="73" x2="110" y2="73" />
                            <path d="M82 73 L74 68 L74 78 Z M102 73 L110 68 L110 78 Z" fill="currentColor" />
                        </g>
                        <text x="92" y="65" text-anchor="middle" fill="currentColor" font-family="JetBrains Mono, monospace" font-size="11">
                            s
                        </text>
                    </svg>
                }
                @case ('post-width') {
                    <svg rtElem="svg" viewBox="0 0 200 140" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
                        <g fill="none" stroke="currentColor" stroke-width="1.5">
                            <rect x="78" y="32" width="44" height="84" />
                            <rect x="74" y="24" width="52" height="10" />
                            <line x1="78" y1="126" x2="122" y2="126" />
                            <path d="M78 121 L78 131 M122 121 L122 131" />
                            <path d="M84 126 L78 121 L78 131 Z M116 126 L122 121 L122 131 Z" fill="currentColor" />
                        </g>
                    </svg>
                }
                @case ('materials') {
                    <svg rtElem="svg" viewBox="0 0 200 140" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
                        <g fill="none" stroke="currentColor" stroke-width="1.5">
                            <rect x="40" y="48" width="120" height="18" />
                            <rect x="40" y="72" width="120" height="18" />
                            <rect x="40" y="96" width="120" height="18" />
                            <line x1="55" y1="57" x2="145" y2="57" stroke-width="1" />
                            <line x1="55" y1="81" x2="145" y2="81" stroke-width="1" />
                            <line x1="55" y1="105" x2="145" y2="105" stroke-width="1" />
                        </g>
                    </svg>
                }
            }
        }
    </div>

    <div rtElem="body">
        @if (groupLabel()) {
            <span rtElem="badge">{{ groupLabel() }}</span>
        }
        <!-- Карточка прямо под заголовком страницы — второй уровень, под заголовком раздела — третий: уровни без пропуска. -->
        @if (topLevel()) {
            <h2 rtElem="title">{{ title() }}</h2>
        } @else {
            <h3 rtElem="title">{{ title() }}</h3>
        }
        <p rtElem="description">{{ description() }}</p>
    </div>
</ng-container>
